import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { ContractPage } from '@/features/contracts'
import { usePanelStore } from '@/components/conversation/panel-store'

export const Route = createFileRoute('/_layout/_app/contracts/$id')({
  component: ContractsRoute,
  staticData: { title: 'Pogodbe' },
})

function ContractsRoute() {
  const { id } = Route.useParams()
  const closePanel = usePanelStore((s) => s.closePanel)

  useEffect(() => {
    closePanel(true)
  }, [id])

  useEffect(() => {
    return () => closePanel(true)
  }, [])

  return <ContractPage id={id} />
}
